import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-partyOrgan",
  "use": "icon-partyOrgan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-partyOrgan\"><path d=\"M902.7 66.6c-10.2-4.4-22.1-2.2-29.8 5.6-0.8 0.8-78.8 77.7-198.1 77.7-34.2 0-69.1-6.4-103.4-19.1-29.3-10.8-60.9-21.9-93-30.1-35.9-9.1-68.7-13.5-100.4-13.5-57.5 0-141.7 25.2-208.4 60.9L157.4 106c-3.5-12-15.2-19.9-28-18.7-12.8 1.2-22.8 11.1-23.9 23.5v0.4c-0.3 3.1 0 6.2 0.9 9.1l21.4 74.5c0.4 1.2 0.8 2.4 1.3 3.5l182 628.1L343.3 940c0.7 2.4 1.7 4.7 3.1 6.8l1.1 1.7c5 7.7 13.6 12.1 22.5 12.1 3.6 0 7.2-0.7 10.7-2.2 12.1-5.2 18.4-18.2 14.8-30.6l-33.4-115.2-37.2-130.8c14.8-35.8 43.1-64.4 84.1-84.9 37.3-18.6 84.6-29.3 129.6-29.3 14.3 0 29.5 1.1 45 3.2 17.3 2.4 34.6 3.6 51.7 3.6 155 0 247.1-96.9 250.9-101 4-4.3 6.4-9.8 6.8-15.6l25.4-366c0.7-10.7-5.5-20.8-15.7-25.2z\" fill=\"#FD2E2E\" p-id=\"16257\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/partyOrgan.svg
// module id = X9Ad
// module chunks = 252